import React from "react";
import { Box, IconButton, Grid, makeStyles } from "@material-ui/core";
import SearchBar from "./SearchBar";
import Add from "@material-ui/icons/AddCircle";

const useStyles = makeStyles((theme) => ({
  toolbar: {
    alignItems: "center",
  },
  addButton: {
    color: theme.palette.primary.main,
    transition: "transform 0.18s ease, box-shadow 0.18s ease",
    "&:hover": {
      backgroundColor: "rgba(233, 58, 36, 0.07)",
      transform: "scale(1.1)",
    },
    "& svg": {
      filter: "drop-shadow(0 2px 6px rgba(233, 58, 36, 0.30))",
    },
  },
}));

const TableToolbar = ({
  searchLabel = "",
  searchChange = () => {},
  add = true,
  addLabel = "",
  addAction = () => {},
  refresh = true,
  refreshLabel = true,
  refreshAction = () => {},
}) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.toolbar}>
      <Grid item xs={add ? 10 : 12} sm={8} md={6}>
        <SearchBar label={searchLabel} handleChange={searchChange} />
      </Grid>
      <Box flexGrow={1} />
      {add ? (
        <Grid item xs={2} sm={4} md={6} align="right">
          <IconButton
            className={classes.addButton}
            aria-label={addLabel}
            onClick={addAction}
          >
            <Add fontSize="large" />
          </IconButton>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default TableToolbar;
